<template>
  <MobileHeader
    :tabs="$route.name"
    isShowHeader
  ></MobileHeader>

  <div class="fav-container-box" :class="{
    'min-height-100vh': $route.name !== 'footballFavMatches'
  }">
    <div :class="` ${!isMobile ? 'container has-header py32' : ''}`">
    
      <div class="flex-shrink-0">
        <FavSidebar 
          ref="favSideBar"
          @favTeamSuccess="favTeamSuccess" />
      </div>
      <div class="fav-match-container display-flex">
        
        <div class="display-flex flex-col w-100">
          <div id="fav-nav"></div>
          <router-view :favTeamUpdate="favTeamUpdate" @updateToTeamTab="updateToTeamTab"></router-view>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import MobileHeader from "@/components/mobile/Header.vue";
import { mapGetters, mapActions } from "vuex";
import FavSidebar from './Sidebar.vue'

export default {
  components: {
    MobileHeader,
    FavSidebar
  },
  data() {
    return {
      favTeamUpdate: false,  
      // tabs: [],
      // footballTabs: [
      //   {
      //     name: "MATCHES",
      //     pathName: "footballFavMatches",
      //     selected: true,
      //   },
      //   {
      //     name: "TEAMS",
      //     pathName: "footballFavTeams",
      //     selected: false,
      //   },
      //   {
      //     name: "COMPETITIONS",
      //     pathName: "footballFavCompetitions",
      //     selected: false,
      //   },
      // ],
      // basketballTabs: [
      //   {
      //     name: "MATCHES",
      //     pathName: "basketballFavMatches",
      //     selected: true,
      //   },
      //   {
      //     name: "TEAMS",
      //     pathName: "basketballFavTeams",
      //     selected: false,
      //   },
      //   {
      //     name: "COMPETITIONS",
      //     pathName: "basketballFavCompetitions",
      //     selected: false,
      //   },
      // ],
      // currentTab: [],
    };
  },
  computed: {
    ...mapGetters([
      "isMobile", 
      "isLogin",
      "currentLocale",
      "currentSportType",
    ]),
  },
  watch: {
    isLogin: {
        deep: true,
        handler(newVal, oldVal) {
            if (!newVal) {
              this.$router.push({ name: 'home'})
            }
        },
    },
    // currentSportType: {
    //   immediate: true,
    //   handler(newVal, oldVal) {
    //     if (newVal === "football")
    //       this.tabs = this.footballTabs;
    //     else if (newVal === "basketball")
    //       this.tabs = this.basketballTabs;
    //   },
    // },
  },
  mounted() {
    this.commonVerifyLogin();
    if (!this.isLogin) {
      location.href = `/${this.currentLocale}`
    }
  },
  methods: {
    ...mapActions([
      "commonVerifyLogin",
    ]),
    favTeamSuccess() {
      this.favTeamUpdate = !this.favTeamUpdate
    },
    updateToTeamTab() {
      this.$refs.favSideBar.updateToTeamTab()
    }
  },
};
</script>

<style>
.fav-title {
  font-family: var(--weight-700);
  font-size: 20px;
  margin-bottom: 16px;
  color: var(--color-text-default-default);
}
.fav-subtitle {
  font-size: 0.875rem;
  line-height: 1.3rem;
  color: #6F8C9B;
  margin: 1rem auto;
  text-align: center;
  /* display: inline-block;
  vertical-align: middle; */
  width: 14rem;
}
.fav-subtitle-1line{
  width: 100%;
}
.fav-nav__wrapper {
  margin: 1rem auto;
  width: 37.5rem;
}
.fav-content__wrapper {
  margin: 0 auto;
  width: 100%;
  min-height: 31.25rem;
  align-items: center;
}
.fav-search {
  width: 100%;
}
.fav-search input {
  cursor: pointer;
}
.fav-card__container {
  width: 100%;
  /* min-height: 29.25rem; */
  gap: 0.5rem;
  margin: 0.5rem 0;
}
.fav-search-icon {
  margin: 0 0.25rem;
  display: inline-block;
  vertical-align: middle;
}
.fav-icon__sample{
    position: relative;
    top: 3px;
    margin-right: 4px;
}
@media(max-width: 768px) { /* for test */
  .fav-nav__wrapper {
    width: 100%;
  }
  .fav-content__wrapper {
    width: 100%;
  }
}
</style>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  gap: 24px;
}
.py32 {
  padding-top: 32px;
  padding-bottom: 32px;
}
.fav-match-container {
  width: 576px;
}
.flex-shrink-0 {
  flex-shrink: 0;
}

.min-height-100vh {
  min-height: calc(100vh - 60.41px);

}
.fav-container-box {
background-color: var(--color-background-default-default);
}
@media(max-width: 768px) { /* for test */
  .container {
    padding-top: 45.59px;    
    display: block;
  }
  .fav-match-container {
    width: 100%;
  }
  .fav-container-box {
    
    padding-bottom: 60px;
  }
}
</style>